import React, { PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import ReactTags from "react-tag-autocomplete";

class formAddTags extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    tags: [],
    userTags: [],
  };

  componentDidMount() {
    this.inputRef = React.createRef();
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  cancelCreation = () => {
    this.props.reset();
    this.props.cancelCreation();
  };

  onAdditionUserTag(tag) {
    let temp = this.props.suggestions.filter((obj) => obj.name === tag.name);

    if (temp.length > 0) {
      const tags = [].concat(this.state.tags, temp.shift());
      this.setState({ tags }, () => {
        this.props.handleForm({ tags: this.state.tags });
      });
    } else {
      const tags = [].concat(this.state.tags, {
        id: tag.name,
        name: tag.name,
        tag: tag.name,
      });
      this.setState({ tags }, () => {
        this.props.handleForm({ tags: this.state.tags });
      });
    }
  }

  onDeleteUserTag(i) {
    const tags = this.state.tags.slice(0);
    tags.splice(i, 1);
    this.setState({ tags }, () => {
      this.props.handleForm({ tags: this.state.tags });
    });
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">{this.props.title}</h5>
        </div>

        <Row>
          <Col md={12} lg={12} xl={12}>
            <div className="form profile-audit-log">
              <div className="form__form-group search-bar">
                <div className="form__form-group-field">
                  <ReactTags
                    rref={this.inputRef}
                    tags={this.state.tags}
                    allowNew={true}
                    suggestions={this.props.suggestions}
                    onDelete={this.onDeleteUserTag.bind(this)}
                    onAddition={this.onAdditionUserTag.bind(this)}
                    placeholderText="Select List"
                    addOnBlur={true}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    );
  }
}

formAddTags = reduxForm({
  // a unique name for the form
  form: "users_form_add_tags",
})(formAddTags);

export default formAddTags;
